import { workflowAxiosGet } from "../utils/workflowAuthHeaders";

const BASE_URL = "https://workflow.grupocenze.com.br:38137/rest/";

/** GET INT_SHELL_CRM_PRODUTO — lista dos outros produtos */
const fetchProdutosShellCrm = async ({
  empresa = "01",
  filial = "01",
  token,
  username,
  password,
} = {}) => {
  try {
    const response = await workflowAxiosGet(
      `${BASE_URL}INT_SHELL_CRM_PRODUTO`,
      {
        params: {
          empresa,
          filial,
        },
      },
      { token, username, password }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar produtos Shell (CRM):", error);
    throw error;
  }
};

export default fetchProdutosShellCrm;
